import styled from 'styled-components'

const MyDiv = styled.div`
.custom_table{
    margin-top: 20px;
}
`
export default MyDiv
